/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { Icon, ToggleField } from '@jutro/components';
import { InputField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './PublicationComponent.module.scss';
import metadata from './PublicationComponent.metadata.json5';

function PublicationComponent(props) {

    const {
        data: PublicationVM,
        updateWizardData,
        submissionVM,
        PublicationPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addPublication = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            PublicationVM.value = PublicationVM.value || []

            const { _xCenter, _dtoName } = PublicationVM;

            const PublicationObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );
            
            PublicationObjVM.isValidationReq = true
            PublicationObjVM.doeTheAppPubANewOr32 = _.get(submissionVM.value, 'lobData.proLine.coverables.accountantCoverable.additionalInformation.doeTheAppPubANewOr32')

            PublicationVM.pushElement(
                PublicationObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, PublicationVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            PublicationVM.value.splice(index, 1);
            _.set(submissionVM.value, PublicationPath, PublicationVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, PublicationPath, PublicationVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {

            item.isValidationReq = true
            item.doeTheAppPubANewOr32 = _.get(submissionVM.value, 'lobData.proLine.coverables.accountantCoverable.additionalInformation.doeTheAppPubANewOr32')
            
            const { path } = props;

            if (path === 'titOfEacPub1') {
                const value = item.titOfEacPub1 ? item.titOfEacPub1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.titOfEacPub1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            } 

            if (path === 'doTheSubOfThePubS') {
                const value = item.doTheSubOfThePubS;

                return (
                    <ToggleField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        onValueChange={(val, changedPath) => {
                            item.doTheSubOfThePubS = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}

                    />

    
                );
            }


        }, [handleValueChange, submissionVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`PublicationTable`]: {
            data: PublicationVM.value,
        }

    }), [PublicationVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addPublication,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            PublicationVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [PublicationVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={PublicationVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PublicationComponent.propTypes = wizardProps;
export default withRouter(PublicationComponent);
